import script from "./city.vue?vue&type=script&setup=true&lang=js"
export * from "./city.vue?vue&type=script&setup=true&lang=js"

import "./city.vue?vue&type=style&index=0&id=18422b7d&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18422b7d"]])

export default __exports__